var map = {
	"./ADR/ExternalLoginADR": 338,
	"./ADR/ExternalLoginADR/": 338,
	"./ADR/ExternalLoginADR/index": 338,
	"./ADR/ExternalLoginADR/index.jsx": 338,
	"./Access/Group/Create": 529,
	"./Access/Group/Create/": 529,
	"./Access/Group/Create/Create-documentation.md": 1192,
	"./Access/Group/Create/index": 529,
	"./Access/Group/Create/index.js": 529,
	"./Access/Group/List": 340,
	"./Access/Group/List/": 340,
	"./Access/Group/List/List-documentation.md": 1212,
	"./Access/Group/List/index": 340,
	"./Access/Group/List/index.js": 340,
	"./Access/Region/Create": 342,
	"./Access/Region/Create/": 342,
	"./Access/Region/Create/Create-documentation.md": 1213,
	"./Access/Region/Create/index": 342,
	"./Access/Region/Create/index.js": 342,
	"./Access/Region/List": 343,
	"./Access/Region/List/": 343,
	"./Access/Region/List/List-documentation.md": 1226,
	"./Access/Region/List/index": 343,
	"./Access/Region/List/index.js": 343,
	"./Access/Role/Create": 344,
	"./Access/Role/Create/": 344,
	"./Access/Role/Create/Create-documentation.md": 1240,
	"./Access/Role/Create/index": 344,
	"./Access/Role/Create/index.js": 344,
	"./Access/Role/Create/styles.css": 1002,
	"./Access/Role/List": 345,
	"./Access/Role/List/": 345,
	"./Access/Role/List/List-documentation.md": 1241,
	"./Access/Role/List/index": 345,
	"./Access/Role/List/index.js": 345,
	"./Access/School/Create": 346,
	"./Access/School/Create/": 346,
	"./Access/School/Create/Create-documentation.md": 1242,
	"./Access/School/Create/index": 346,
	"./Access/School/Create/index.js": 346,
	"./Access/School/List": 347,
	"./Access/School/List/": 347,
	"./Access/School/List/List-documentation.md": 1243,
	"./Access/School/List/index": 347,
	"./Access/School/List/index.js": 347,
	"./Access/Users/Consulta": 348,
	"./Access/Users/Consulta/": 348,
	"./Access/Users/Consulta/index": 348,
	"./Access/Users/Consulta/index.js": 348,
	"./Access/Users/Create": 349,
	"./Access/Users/Create/": 349,
	"./Access/Users/Create/Create-documentation.md": 1244,
	"./Access/Users/Create/index": 349,
	"./Access/Users/Create/index.js": 349,
	"./Access/Users/List": 530,
	"./Access/Users/List/": 530,
	"./Access/Users/List/List-documentation.md": 1245,
	"./Access/Users/List/index": 530,
	"./Access/Users/List/index.js": 530,
	"./Access/Users/users.css": 1003,
	"./Activity/Activity/ActivityActivity-documentation.md": 1246,
	"./Activity/Activity/Allocate": 531,
	"./Activity/Activity/Allocate/": 531,
	"./Activity/Activity/Allocate/Allocate-documentation.md": 1247,
	"./Activity/Activity/Allocate/index": 531,
	"./Activity/Activity/Allocate/index.js": 531,
	"./Activity/Activity/Allocate/style.css": 1004,
	"./Activity/Activity/Bank": 532,
	"./Activity/Activity/Bank/": 532,
	"./Activity/Activity/Bank/Bank-documentation.md": 1248,
	"./Activity/Activity/Bank/index": 532,
	"./Activity/Activity/Bank/index.jsx": 532,
	"./Activity/Activity/Correct": 350,
	"./Activity/Activity/Correct/": 350,
	"./Activity/Activity/Correct/Correct-documentation.md": 1256,
	"./Activity/Activity/Correct/index": 350,
	"./Activity/Activity/Correct/index.js": 350,
	"./Activity/Activity/Correct/style.css": 1257,
	"./Activity/Activity/Create": 351,
	"./Activity/Activity/Create/": 351,
	"./Activity/Activity/Create/Create-documentation.md": 1272,
	"./Activity/Activity/Create/index": 351,
	"./Activity/Activity/Create/index.js": 351,
	"./Activity/Activity/Do": 533,
	"./Activity/Activity/Do/": 533,
	"./Activity/Activity/Do/Do-documentation.md": 1273,
	"./Activity/Activity/Do/activityItemStatistics": 806,
	"./Activity/Activity/Do/activityItemStatistics.jsx": 806,
	"./Activity/Activity/Do/evaluationStatistics": 604,
	"./Activity/Activity/Do/evaluationStatistics.jsx": 604,
	"./Activity/Activity/Do/index": 533,
	"./Activity/Activity/Do/index.jsx": 533,
	"./Activity/Activity/Do/style.css": 723,
	"./Activity/Activity/List": 520,
	"./Activity/Activity/List/": 520,
	"./Activity/Activity/List/List-documentation.md": 1274,
	"./Activity/Activity/List/index": 520,
	"./Activity/Activity/List/index.js": 520,
	"./Activity/Activity/Live": 524,
	"./Activity/Activity/Live/": 524,
	"./Activity/Activity/Live/Live-documentation.md": 1324,
	"./Activity/Activity/Live/index": 524,
	"./Activity/Activity/Live/index.jsx": 524,
	"./Activity/Activity/Live/style.scss": 1016,
	"./Activity/Activity/Me": 354,
	"./Activity/Activity/Me/": 354,
	"./Activity/Activity/Me/Me-documentation.md": 1325,
	"./Activity/Activity/Me/index": 354,
	"./Activity/Activity/Me/index.js": 354,
	"./Activity/Activity/Me/style.css": 1037,
	"./Activity/Activity/Show": 355,
	"./Activity/Activity/Show/": 355,
	"./Activity/Activity/Show/index": 355,
	"./Activity/Activity/Show/index.js": 355,
	"./Activity/Activity/TV/Report": 356,
	"./Activity/Activity/TV/Report/": 356,
	"./Activity/Activity/TV/Report/TVReport-documentation.md": 1326,
	"./Activity/Activity/TV/Report/index": 356,
	"./Activity/Activity/TV/Report/index.jsx": 356,
	"./Activity/Activity/TV/Share": 357,
	"./Activity/Activity/TV/Share/": 357,
	"./Activity/Activity/TV/Share/index": 357,
	"./Activity/Activity/TV/Share/index.jsx": 357,
	"./Activity/Activity/View": 358,
	"./Activity/Activity/View/": 358,
	"./Activity/Activity/View/View-documentation.md": 1327,
	"./Activity/Activity/View/index": 358,
	"./Activity/Activity/View/index.js": 358,
	"./Activity/Literarte": 359,
	"./Activity/Literarte/": 359,
	"./Activity/Literarte/Literarte-documentation.md": 1328,
	"./Activity/Literarte/index": 359,
	"./Activity/Literarte/index.jsx": 359,
	"./Activity/Literarte/styles.css": 1038,
	"./Activity/Trail/Activity": 360,
	"./Activity/Trail/Activity/": 360,
	"./Activity/Trail/Activity/Activity-documentation.md": 1329,
	"./Activity/Trail/Activity/activityItemStatistics": 812,
	"./Activity/Trail/Activity/activityItemStatistics.jsx": 812,
	"./Activity/Trail/Activity/evaluationStatistics": 559,
	"./Activity/Trail/Activity/evaluationStatistics.jsx": 559,
	"./Activity/Trail/Activity/index": 360,
	"./Activity/Trail/Activity/index.jsx": 360,
	"./Activity/Trail/Activity/statistics": 552,
	"./Activity/Trail/Activity/statistics.jsx": 552,
	"./Activity/Trail/Activity/style.css": 729,
	"./Activity/Trail/Allocate": 361,
	"./Activity/Trail/Allocate/": 361,
	"./Activity/Trail/Allocate/Allocate-documentation.md": 1330,
	"./Activity/Trail/Allocate/index": 361,
	"./Activity/Trail/Allocate/index.js": 361,
	"./Activity/Trail/Allocate/style.css": 1039,
	"./Activity/Trail/Bank": 362,
	"./Activity/Trail/Bank/": 362,
	"./Activity/Trail/Bank/Bank-documentation.md": 1331,
	"./Activity/Trail/Bank/index": 362,
	"./Activity/Trail/Bank/index.jsx": 362,
	"./Activity/Trail/Correct": 363,
	"./Activity/Trail/Correct/": 363,
	"./Activity/Trail/Correct/Correct-documentation.md": 1332,
	"./Activity/Trail/Correct/index": 363,
	"./Activity/Trail/Correct/index.js": 363,
	"./Activity/Trail/Correct/style.css": 1333,
	"./Activity/Trail/Do": 518,
	"./Activity/Trail/Do/": 518,
	"./Activity/Trail/Do/Do-documentation.md": 1335,
	"./Activity/Trail/Do/index": 518,
	"./Activity/Trail/Do/index.jsx": 518,
	"./Activity/Trail/Do/style.css": 1040,
	"./Activity/Trail/Edit": 364,
	"./Activity/Trail/Edit/": 364,
	"./Activity/Trail/Edit/index": 364,
	"./Activity/Trail/Edit/index.jsx": 364,
	"./Activity/Trail/Edit/style.css": 1041,
	"./Activity/Trail/Grade/Send": 365,
	"./Activity/Trail/Grade/Send/": 365,
	"./Activity/Trail/Grade/Send/index": 365,
	"./Activity/Trail/Grade/Send/index.jsx": 365,
	"./Activity/Trail/Grade/Send/styles.css": 1042,
	"./Activity/Trail/Grade/Show": 366,
	"./Activity/Trail/Grade/Show/": 366,
	"./Activity/Trail/Grade/Show/index": 366,
	"./Activity/Trail/Grade/Show/index.jsx": 366,
	"./Activity/Trail/List": 534,
	"./Activity/Trail/List/": 534,
	"./Activity/Trail/List/List-documentation.md": 1336,
	"./Activity/Trail/List/index": 534,
	"./Activity/Trail/List/index.jsx": 534,
	"./Activity/Trail/PartialProgression/AllocateByTrail": 367,
	"./Activity/Trail/PartialProgression/AllocateByTrail/": 367,
	"./Activity/Trail/PartialProgression/AllocateByTrail/index": 367,
	"./Activity/Trail/PartialProgression/AllocateByTrail/index.jsx": 367,
	"./Activity/Trail/PartialProgression/AllocateByUser": 368,
	"./Activity/Trail/PartialProgression/AllocateByUser/": 368,
	"./Activity/Trail/PartialProgression/AllocateByUser/index": 368,
	"./Activity/Trail/PartialProgression/AllocateByUser/index.jsx": 368,
	"./Activity/Trail/PartialProgression/Bank": 369,
	"./Activity/Trail/PartialProgression/Bank/": 369,
	"./Activity/Trail/PartialProgression/Bank/index": 369,
	"./Activity/Trail/PartialProgression/Bank/index.jsx": 369,
	"./Activity/Trail/PartialProgression/Grade/Send": 370,
	"./Activity/Trail/PartialProgression/Grade/Send/": 370,
	"./Activity/Trail/PartialProgression/Grade/Send/index": 370,
	"./Activity/Trail/PartialProgression/Grade/Send/index.jsx": 370,
	"./Activity/Trail/PartialProgression/Grade/Show": 371,
	"./Activity/Trail/PartialProgression/Grade/Show/": 371,
	"./Activity/Trail/PartialProgression/Grade/Show/index": 371,
	"./Activity/Trail/PartialProgression/Grade/Show/index.jsx": 371,
	"./Activity/Trail/PartialProgression/Statistics": 372,
	"./Activity/Trail/PartialProgression/Statistics/": 372,
	"./Activity/Trail/PartialProgression/Statistics/index": 372,
	"./Activity/Trail/PartialProgression/Statistics/index.jsx": 372,
	"./Activity/Trail/Show": 373,
	"./Activity/Trail/Show/": 373,
	"./Activity/Trail/Show/Show-documentation.md": 1337,
	"./Activity/Trail/Show/index": 373,
	"./Activity/Trail/Show/index.jsx": 373,
	"./Activity/Trail/Show/style.css": 1043,
	"./AllocationFinder": 277,
	"./AllocationFinder/": 277,
	"./AllocationFinder/AllocationFinder-documentation.md": 1338,
	"./AllocationFinder/index": 277,
	"./AllocationFinder/index.js": 277,
	"./AllocationFinder/style.css": 976,
	"./Audict/Action/Create": 374,
	"./Audict/Action/Create/": 374,
	"./Audict/Action/Create/Create-documentation.md": 1339,
	"./Audict/Action/Create/index": 374,
	"./Audict/Action/Create/index.js": 374,
	"./Audict/Action/List": 375,
	"./Audict/Action/List/": 375,
	"./Audict/Action/List/List-documentation.md": 1340,
	"./Audict/Action/List/index": 375,
	"./Audict/Action/List/index.js": 375,
	"./Audict/Origin/Create": 376,
	"./Audict/Origin/Create/": 376,
	"./Audict/Origin/Create/Create-documentation.md": 1341,
	"./Audict/Origin/Create/index": 376,
	"./Audict/Origin/Create/index.js": 376,
	"./Audict/Origin/List": 377,
	"./Audict/Origin/List/": 377,
	"./Audict/Origin/List/List-documentation.md": 1342,
	"./Audict/Origin/List/index": 377,
	"./Audict/Origin/List/index.js": 377,
	"./Banner": 378,
	"./Banner/": 378,
	"./Banner/index": 378,
	"./Banner/index.js": 378,
	"./Child": 379,
	"./Child/": 379,
	"./Child/Child-documentation.md": 1343,
	"./Child/index": 379,
	"./Child/index.jsx": 379,
	"./Classification/Ability/Create": 380,
	"./Classification/Ability/Create/": 380,
	"./Classification/Ability/Create/Create-documentation.md": 1344,
	"./Classification/Ability/Create/index": 380,
	"./Classification/Ability/Create/index.js": 380,
	"./Classification/Ability/List": 381,
	"./Classification/Ability/List/": 381,
	"./Classification/Ability/List/List-documentation.md": 1345,
	"./Classification/Ability/List/index": 381,
	"./Classification/Ability/List/index.js": 381,
	"./Classification/DifficultyLevel/Create": 382,
	"./Classification/DifficultyLevel/Create/": 382,
	"./Classification/DifficultyLevel/Create/Create-documentation.md": 1346,
	"./Classification/DifficultyLevel/Create/index": 382,
	"./Classification/DifficultyLevel/Create/index.js": 382,
	"./Classification/DifficultyLevel/List": 383,
	"./Classification/DifficultyLevel/List/": 383,
	"./Classification/DifficultyLevel/List/List-documentation.md": 1347,
	"./Classification/DifficultyLevel/List/index": 383,
	"./Classification/DifficultyLevel/List/index.js": 383,
	"./Classification/Discipline/Create": 384,
	"./Classification/Discipline/Create/": 384,
	"./Classification/Discipline/Create/Create-documentation.md": 1348,
	"./Classification/Discipline/Create/index": 384,
	"./Classification/Discipline/Create/index.js": 384,
	"./Classification/Discipline/List": 385,
	"./Classification/Discipline/List/": 385,
	"./Classification/Discipline/List/List-documentation.md": 1349,
	"./Classification/Discipline/List/index": 385,
	"./Classification/Discipline/List/index.js": 385,
	"./Classification/Goal/Create": 386,
	"./Classification/Goal/Create/": 386,
	"./Classification/Goal/Create/Create-documentation.md": 1350,
	"./Classification/Goal/Create/index": 386,
	"./Classification/Goal/Create/index.js": 386,
	"./Classification/Goal/List": 387,
	"./Classification/Goal/List/": 387,
	"./Classification/Goal/List/List-documentation.md": 1351,
	"./Classification/Goal/List/index": 387,
	"./Classification/Goal/List/index.js": 387,
	"./Classification/Grade/Create": 388,
	"./Classification/Grade/Create/": 388,
	"./Classification/Grade/Create/Create-documentation.md": 1352,
	"./Classification/Grade/Create/index": 388,
	"./Classification/Grade/Create/index.js": 388,
	"./Classification/Grade/List": 389,
	"./Classification/Grade/List/": 389,
	"./Classification/Grade/List/List-documentation.md": 1353,
	"./Classification/Grade/List/index": 389,
	"./Classification/Grade/List/index.js": 389,
	"./Classification/LearningArea/Create": 390,
	"./Classification/LearningArea/Create/": 390,
	"./Classification/LearningArea/Create/Create-documentation.md": 1354,
	"./Classification/LearningArea/Create/index": 390,
	"./Classification/LearningArea/Create/index.js": 390,
	"./Classification/LearningArea/List": 391,
	"./Classification/LearningArea/List/": 391,
	"./Classification/LearningArea/List/List-documentation.md": 1355,
	"./Classification/LearningArea/List/index": 391,
	"./Classification/LearningArea/List/index.js": 391,
	"./Classification/Module/Create": 392,
	"./Classification/Module/Create/": 392,
	"./Classification/Module/Create/Create-documentation.md": 1356,
	"./Classification/Module/Create/index": 392,
	"./Classification/Module/Create/index.js": 392,
	"./Classification/Module/List": 393,
	"./Classification/Module/List/": 393,
	"./Classification/Module/List/List-documentation.md": 1357,
	"./Classification/Module/List/index": 393,
	"./Classification/Module/List/index.js": 393,
	"./Classification/Segment/Create": 394,
	"./Classification/Segment/Create/": 394,
	"./Classification/Segment/Create/Create-documentation.md": 1358,
	"./Classification/Segment/Create/index": 394,
	"./Classification/Segment/Create/index.js": 394,
	"./Classification/Segment/List": 395,
	"./Classification/Segment/List/": 395,
	"./Classification/Segment/List/List-documentation.md": 1359,
	"./Classification/Segment/List/index": 395,
	"./Classification/Segment/List/index.js": 395,
	"./Classification/Source/Create": 396,
	"./Classification/Source/Create/": 396,
	"./Classification/Source/Create/Create-documentation.md": 1360,
	"./Classification/Source/Create/index": 396,
	"./Classification/Source/Create/index.js": 396,
	"./Classification/Source/List": 397,
	"./Classification/Source/List/": 397,
	"./Classification/Source/List/List-documentation.md": 1361,
	"./Classification/Source/List/index": 397,
	"./Classification/Source/List/index.js": 397,
	"./Classification/ThematicUnit/Create": 398,
	"./Classification/ThematicUnit/Create/": 398,
	"./Classification/ThematicUnit/Create/Create-documentation.md": 1362,
	"./Classification/ThematicUnit/Create/index": 398,
	"./Classification/ThematicUnit/Create/index.js": 398,
	"./Classification/ThematicUnit/List": 399,
	"./Classification/ThematicUnit/List/": 399,
	"./Classification/ThematicUnit/List/List-documentation.md": 1363,
	"./Classification/ThematicUnit/List/index": 399,
	"./Classification/ThematicUnit/List/index.js": 399,
	"./Communication/Notification/Create": 400,
	"./Communication/Notification/Create/": 400,
	"./Communication/Notification/Create/Create-documentation.md": 1364,
	"./Communication/Notification/Create/index": 400,
	"./Communication/Notification/Create/index.js": 400,
	"./Communication/Notification/Create/style.css": 1044,
	"./Communication/Notification/Detail": 401,
	"./Communication/Notification/Detail/": 401,
	"./Communication/Notification/Detail/Detail-documentation.md": 1365,
	"./Communication/Notification/Detail/index": 401,
	"./Communication/Notification/Detail/index.js": 401,
	"./Communication/Notification/Detail/style.css": 1045,
	"./Communication/Notification/List": 402,
	"./Communication/Notification/List/": 402,
	"./Communication/Notification/List/List-documentation.md": 1366,
	"./Communication/Notification/List/index": 402,
	"./Communication/Notification/List/index.js": 402,
	"./Communication/Notification/Me": 403,
	"./Communication/Notification/Me/": 403,
	"./Communication/Notification/Me/Me-documentation.md": 1367,
	"./Communication/Notification/Me/index": 403,
	"./Communication/Notification/Me/index.js": 403,
	"./Communication/Notification/Me/style.css": 1046,
	"./Communication/Occurrence/Create": 404,
	"./Communication/Occurrence/Create/": 404,
	"./Communication/Occurrence/Create/Create-documentation.md": 1368,
	"./Communication/Occurrence/Create/index": 404,
	"./Communication/Occurrence/Create/index.js": 404,
	"./Communication/Occurrence/Detail": 405,
	"./Communication/Occurrence/Detail/": 405,
	"./Communication/Occurrence/Detail/Detail-documentation.md": 1369,
	"./Communication/Occurrence/Detail/index": 405,
	"./Communication/Occurrence/Detail/index.js": 405,
	"./Communication/Occurrence/Detail/style.css": 1047,
	"./Communication/Occurrence/List": 406,
	"./Communication/Occurrence/List/": 406,
	"./Communication/Occurrence/List/List-documentation.md": 1370,
	"./Communication/Occurrence/List/index": 406,
	"./Communication/Occurrence/List/index.js": 406,
	"./Communication/Occurrence/Me": 407,
	"./Communication/Occurrence/Me/": 407,
	"./Communication/Occurrence/Me/Me-documentation.md": 1371,
	"./Communication/Occurrence/Me/index": 407,
	"./Communication/Occurrence/Me/index.js": 407,
	"./Communication/Occurrence/Me/style.css": 1048,
	"./Communication/OccurrenceType/Create": 408,
	"./Communication/OccurrenceType/Create/": 408,
	"./Communication/OccurrenceType/Create/Create-documentation.md": 1372,
	"./Communication/OccurrenceType/Create/index": 408,
	"./Communication/OccurrenceType/Create/index.js": 408,
	"./Communication/OccurrenceType/List": 409,
	"./Communication/OccurrenceType/List/": 409,
	"./Communication/OccurrenceType/List/List-documentation.md": 1373,
	"./Communication/OccurrenceType/List/index": 409,
	"./Communication/OccurrenceType/List/index.js": 409,
	"./Community/Classroom/Create": 410,
	"./Community/Classroom/Create/": 410,
	"./Community/Classroom/Create/Create-documentation.md": 1374,
	"./Community/Classroom/Create/index": 410,
	"./Community/Classroom/Create/index.js": 410,
	"./Community/Classroom/Create/styles.css": 1049,
	"./Community/Classroom/Jitsi": 411,
	"./Community/Classroom/Jitsi/": 411,
	"./Community/Classroom/Jitsi/Jitsi-documentation.md": 1375,
	"./Community/Classroom/Jitsi/index": 411,
	"./Community/Classroom/Jitsi/index.js": 411,
	"./Community/Classroom/Jitsi/styles.css": 1050,
	"./Community/Classroom/List": 412,
	"./Community/Classroom/List/": 412,
	"./Community/Classroom/List/List-documentation.md": 1376,
	"./Community/Classroom/List/index": 412,
	"./Community/Classroom/List/index.js": 412,
	"./Community/Classroom/Me": 413,
	"./Community/Classroom/Me/": 413,
	"./Community/Classroom/Me/Me-documentation.md": 1377,
	"./Community/Classroom/Me/index": 413,
	"./Community/Classroom/Me/index.js": 413,
	"./Community/Classroom/Me/styles.css": 1051,
	"./Community/Classroom/Members": 525,
	"./Community/Classroom/Members/": 525,
	"./Community/Classroom/Members/Members-documentation.md": 1378,
	"./Community/Classroom/Members/index": 525,
	"./Community/Classroom/Members/index.js": 525,
	"./Community/Classroom/Members/styles.css": 1052,
	"./Community/Classroom/Migrate": 414,
	"./Community/Classroom/Migrate/": 414,
	"./Community/Classroom/Migrate/Migrate-documentation.md": 1379,
	"./Community/Classroom/Migrate/index": 414,
	"./Community/Classroom/Migrate/index.jsx": 414,
	"./Community/Classroom/Show": 415,
	"./Community/Classroom/Show/": 415,
	"./Community/Classroom/Show/Show-documentation.md": 1381,
	"./Community/Classroom/Show/index": 415,
	"./Community/Classroom/Show/index.js": 415,
	"./Community/Classroom/Show/jitsi": 641,
	"./Community/Classroom/Show/jitsi.js": 641,
	"./Community/Classroom/Show/ranking": 640,
	"./Community/Classroom/Show/ranking.jsx": 640,
	"./Community/Classroom/Show/statistics": 290,
	"./Community/Classroom/Show/statistics.jsx": 290,
	"./Community/Classroom/Show/styles.css": 730,
	"./Community/Room/Create": 416,
	"./Community/Room/Create/": 416,
	"./Community/Room/Create/Create-documentation.md": 1382,
	"./Community/Room/Create/index": 416,
	"./Community/Room/Create/index.js": 416,
	"./Community/Room/Create/users": 813,
	"./Community/Room/Create/users.js": 813,
	"./Community/Room/List": 417,
	"./Community/Room/List/": 417,
	"./Community/Room/List/List-documentation.md": 1383,
	"./Community/Room/List/index": 417,
	"./Community/Room/List/index.js": 417,
	"./Community/Room/Me": 418,
	"./Community/Room/Me/": 418,
	"./Community/Room/Me/Me-documentation.md": 1384,
	"./Community/Room/Me/index": 418,
	"./Community/Room/Me/index.js": 418,
	"./Community/Room/Me/search": 642,
	"./Community/Room/Me/search.js": 642,
	"./Community/Room/Me/styles.css": 1053,
	"./Community/Room/Members": 419,
	"./Community/Room/Members/": 419,
	"./Community/Room/Members/Members-documentation.md": 1385,
	"./Community/Room/Members/index": 419,
	"./Community/Room/Members/index.js": 419,
	"./Community/Room/Show": 420,
	"./Community/Room/Show/": 420,
	"./Community/Room/Show/Show-documentation.md": 1386,
	"./Community/Room/Show/index": 420,
	"./Community/Room/Show/index.js": 420,
	"./Community/Room/Show/styles.css": 1054,
	"./Configuration/ADR/CreateOrigin": 421,
	"./Configuration/ADR/CreateOrigin/": 421,
	"./Configuration/ADR/CreateOrigin/index": 421,
	"./Configuration/ADR/CreateOrigin/index.jsx": 421,
	"./Configuration/ADR/Origin": 422,
	"./Configuration/ADR/Origin/": 422,
	"./Configuration/ADR/Origin/index": 422,
	"./Configuration/ADR/Origin/index.jsx": 422,
	"./Configuration/Component/Create": 423,
	"./Configuration/Component/Create/": 423,
	"./Configuration/Component/Create/Create-documentation.md": 1387,
	"./Configuration/Component/Create/index": 423,
	"./Configuration/Component/Create/index.js": 423,
	"./Configuration/Component/List": 424,
	"./Configuration/Component/List/": 424,
	"./Configuration/Component/List/List-documentation.md": 1388,
	"./Configuration/Component/List/index": 424,
	"./Configuration/Component/List/index.js": 424,
	"./Configuration/Language/Create": 425,
	"./Configuration/Language/Create/": 425,
	"./Configuration/Language/Create/Create-documentation.md": 1389,
	"./Configuration/Language/Create/index": 425,
	"./Configuration/Language/Create/index.js": 425,
	"./Configuration/Language/List": 426,
	"./Configuration/Language/List/": 426,
	"./Configuration/Language/List/List-documentation.md": 1390,
	"./Configuration/Language/List/index": 426,
	"./Configuration/Language/List/index.js": 426,
	"./Configuration/Menu/List": 535,
	"./Configuration/Menu/List/": 535,
	"./Configuration/Menu/List/List-documentation.md": 1391,
	"./Configuration/Menu/List/index": 535,
	"./Configuration/Menu/List/index.js": 535,
	"./Configuration/Menu/List/styles.css": 1055,
	"./Configuration/Module/Create": 427,
	"./Configuration/Module/Create/": 427,
	"./Configuration/Module/Create/Create-documentation.md": 1392,
	"./Configuration/Module/Create/index": 427,
	"./Configuration/Module/Create/index.js": 427,
	"./Configuration/Module/List": 428,
	"./Configuration/Module/List/": 428,
	"./Configuration/Module/List/List-documentation.md": 1393,
	"./Configuration/Module/List/index": 428,
	"./Configuration/Module/List/index.js": 428,
	"./Configuration/Role/Create": 429,
	"./Configuration/Role/Create/": 429,
	"./Configuration/Role/Create/Create-documentation.md": 1394,
	"./Configuration/Role/Create/index": 429,
	"./Configuration/Role/Create/index.js": 429,
	"./Configuration/Role/Create/styles.css": 1056,
	"./Configuration/Role/List": 430,
	"./Configuration/Role/List/": 430,
	"./Configuration/Role/List/List-documentation.md": 1395,
	"./Configuration/Role/List/index": 430,
	"./Configuration/Role/List/index.js": 430,
	"./Configuration/SocialNetwork/Create": 431,
	"./Configuration/SocialNetwork/Create/": 431,
	"./Configuration/SocialNetwork/Create/Create-documentation.md": 1396,
	"./Configuration/SocialNetwork/Create/index": 431,
	"./Configuration/SocialNetwork/Create/index.js": 431,
	"./Configuration/SocialNetwork/List": 432,
	"./Configuration/SocialNetwork/List/": 432,
	"./Configuration/SocialNetwork/List/List-documentation.md": 1397,
	"./Configuration/SocialNetwork/List/index": 432,
	"./Configuration/SocialNetwork/List/index.js": 432,
	"./Configuration/Translation/Create": 433,
	"./Configuration/Translation/Create/": 433,
	"./Configuration/Translation/Create/Create-documentation.md": 1398,
	"./Configuration/Translation/Create/index": 433,
	"./Configuration/Translation/Create/index.js": 433,
	"./Configuration/Translation/List": 434,
	"./Configuration/Translation/List/": 434,
	"./Configuration/Translation/List/List-documentation.md": 1399,
	"./Configuration/Translation/List/index": 434,
	"./Configuration/Translation/List/index.js": 434,
	"./Consolidated/Panel": 435,
	"./Consolidated/Panel/": 435,
	"./Consolidated/Panel/Panel-documentation.md": 1400,
	"./Consolidated/Panel/filter": 643,
	"./Consolidated/Panel/filter.jsx": 643,
	"./Consolidated/Panel/index": 435,
	"./Consolidated/Panel/index.jsx": 435,
	"./Content/Docs/Me": 436,
	"./Content/Docs/Me/": 436,
	"./Content/Docs/Me/Me-documentation.md": 1401,
	"./Content/Docs/Me/edit": 645,
	"./Content/Docs/Me/edit.js": 645,
	"./Content/Docs/Me/folder": 647,
	"./Content/Docs/Me/folder.js": 647,
	"./Content/Docs/Me/index": 436,
	"./Content/Docs/Me/index.js": 436,
	"./Content/Docs/Me/info": 648,
	"./Content/Docs/Me/info.js": 648,
	"./Content/Docs/Me/permission": 644,
	"./Content/Docs/Me/permission.js": 644,
	"./Content/Docs/Me/style.css": 1057,
	"./Content/Docs/Me/upload": 646,
	"./Content/Docs/Me/upload.js": 646,
	"./Content/HandsOn": 437,
	"./Content/HandsOn/": 437,
	"./Content/HandsOn/default.png": 844,
	"./Content/HandsOn/favorites.webp": 845,
	"./Content/HandsOn/handson.webp": 1402,
	"./Content/HandsOn/index": 437,
	"./Content/HandsOn/index.jsx": 437,
	"./Content/HandsOn/roulette.webp": 846,
	"./Content/HandsOn/styles.css": 1058,
	"./Content/Library": 438,
	"./Content/Library/": 438,
	"./Content/Library/Library-documentation.md": 1403,
	"./Content/Library/index": 438,
	"./Content/Library/index.jsx": 438,
	"./Content/LibraryCurriculum": 536,
	"./Content/LibraryCurriculum/": 536,
	"./Content/LibraryCurriculum/index": 536,
	"./Content/LibraryCurriculum/index.jsx": 536,
	"./Content/List": 439,
	"./Content/List/": 439,
	"./Content/List/List-documentation.md": 1404,
	"./Content/List/index": 439,
	"./Content/List/index.js": 439,
	"./Content/Lo/Create": 440,
	"./Content/Lo/Create/": 440,
	"./Content/Lo/Create/Create-documentation.md": 1405,
	"./Content/Lo/Create/index": 440,
	"./Content/Lo/Create/index.js": 440,
	"./Content/Lo/List": 441,
	"./Content/Lo/List/": 441,
	"./Content/Lo/List/List-documentation.md": 1406,
	"./Content/Lo/List/index": 441,
	"./Content/Lo/List/index.js": 441,
	"./Content/Skin/Create": 442,
	"./Content/Skin/Create/": 442,
	"./Content/Skin/Create/Create-documentation.md": 1407,
	"./Content/Skin/Create/index": 442,
	"./Content/Skin/Create/index.js": 442,
	"./Content/Skin/List": 443,
	"./Content/Skin/List/": 443,
	"./Content/Skin/List/List-documentation.md": 1408,
	"./Content/Skin/List/index": 443,
	"./Content/Skin/List/index.js": 443,
	"./Content/Type/Create": 444,
	"./Content/Type/Create/": 444,
	"./Content/Type/Create/Create-documentation.md": 1409,
	"./Content/Type/Create/index": 444,
	"./Content/Type/Create/index.js": 444,
	"./Content/Type/List": 445,
	"./Content/Type/List/": 445,
	"./Content/Type/List/List-documentation.md": 1410,
	"./Content/Type/List/index": 445,
	"./Content/Type/List/index.js": 445,
	"./Content/View": 516,
	"./Content/View/": 516,
	"./Content/View/View-documentation.md": 1412,
	"./Content/View/index": 516,
	"./Content/View/index.jsx": 516,
	"./DailyRecord/Create": 446,
	"./DailyRecord/Create/": 446,
	"./DailyRecord/Create/Create-documentation.md": 1413,
	"./DailyRecord/Create/index": 446,
	"./DailyRecord/Create/index.jsx": 446,
	"./DailyRecord/Create/style.css": 1059,
	"./DailyRecord/Edit": 447,
	"./DailyRecord/Edit/": 447,
	"./DailyRecord/Edit/Edit-documentation.md": 1414,
	"./DailyRecord/Edit/index": 447,
	"./DailyRecord/Edit/index.jsx": 447,
	"./DailyRecord/Edit/style.css": 1415,
	"./DailyRecord/List": 448,
	"./DailyRecord/List/": 448,
	"./DailyRecord/List/List-documentation.md": 1416,
	"./DailyRecord/List/index": 448,
	"./DailyRecord/List/index.jsx": 448,
	"./DailyRecord/View": 449,
	"./DailyRecord/View/": 449,
	"./DailyRecord/View/View-documentation.md": 1417,
	"./DailyRecord/View/index": 449,
	"./DailyRecord/View/index.jsx": 449,
	"./Dashboard": 450,
	"./Dashboard/": 450,
	"./Dashboard/Dashboard-documentation.md": 1418,
	"./Dashboard/index": 450,
	"./Dashboard/index.js": 450,
	"./DigitalBooks/List": 451,
	"./DigitalBooks/List/": 451,
	"./DigitalBooks/List/index": 451,
	"./DigitalBooks/List/index.jsx": 451,
	"./DigitalBooks/List/styles.css": 1060,
	"./Education/Curriculum/Create": 452,
	"./Education/Curriculum/Create/": 452,
	"./Education/Curriculum/Create/Create-documentation.md": 1419,
	"./Education/Curriculum/Create/index": 452,
	"./Education/Curriculum/Create/index.js": 452,
	"./Education/Curriculum/List": 453,
	"./Education/Curriculum/List/": 453,
	"./Education/Curriculum/List/List-documentation.md": 1420,
	"./Education/Curriculum/List/index": 453,
	"./Education/Curriculum/List/index.js": 453,
	"./Education/CurriculumReport": 526,
	"./Education/CurriculumReport/": 526,
	"./Education/CurriculumReport/Report-documentation.md": 1421,
	"./Education/CurriculumReport/index": 526,
	"./Education/CurriculumReport/index.jsx": 526,
	"./Education/Method/Create": 454,
	"./Education/Method/Create/": 454,
	"./Education/Method/Create/Create-documentation.md": 1422,
	"./Education/Method/Create/index": 454,
	"./Education/Method/Create/index.js": 454,
	"./Education/Method/List": 455,
	"./Education/Method/List/": 455,
	"./Education/Method/List/List-documentation.md": 1423,
	"./Education/Method/List/index": 455,
	"./Education/Method/List/index.js": 455,
	"./Education/Period/Create": 456,
	"./Education/Period/Create/": 456,
	"./Education/Period/Create/Create-documentation.md": 1424,
	"./Education/Period/Create/index": 456,
	"./Education/Period/Create/index.js": 456,
	"./Education/Period/List": 457,
	"./Education/Period/List/": 457,
	"./Education/Period/List/List-documentation.md": 1425,
	"./Education/Period/List/index": 457,
	"./Education/Period/List/index.js": 457,
	"./Education/Resource/Create": 458,
	"./Education/Resource/Create/": 458,
	"./Education/Resource/Create/Create-documentation.md": 1426,
	"./Education/Resource/Create/index": 458,
	"./Education/Resource/Create/index.js": 458,
	"./Education/Resource/List": 459,
	"./Education/Resource/List/": 459,
	"./Education/Resource/List/List-documentation.md": 1427,
	"./Education/Resource/List/index": 459,
	"./Education/Resource/List/index.js": 459,
	"./Emotions/List": 521,
	"./Emotions/List/": 521,
	"./Emotions/List/List-documentation.md": 1428,
	"./Emotions/List/index": 521,
	"./Emotions/List/index.jsx": 521,
	"./Evaluation/ADR/Allocate": 460,
	"./Evaluation/ADR/Allocate/": 460,
	"./Evaluation/ADR/Allocate/index": 460,
	"./Evaluation/ADR/Allocate/index.jsx": 460,
	"./Evaluation/ADR/Allocate/style.css": 1061,
	"./Evaluation/ADR/AllocateList": 461,
	"./Evaluation/ADR/AllocateList/": 461,
	"./Evaluation/ADR/AllocateList/index": 461,
	"./Evaluation/ADR/AllocateList/index.jsx": 461,
	"./Evaluation/ADR/Bank": 462,
	"./Evaluation/ADR/Bank/": 462,
	"./Evaluation/ADR/Bank/index": 462,
	"./Evaluation/ADR/Bank/index.jsx": 462,
	"./Evaluation/ADR/Create": 463,
	"./Evaluation/ADR/Create/": 463,
	"./Evaluation/ADR/Create/index": 463,
	"./Evaluation/ADR/Create/index.js": 463,
	"./Evaluation/ADR/List": 464,
	"./Evaluation/ADR/List/": 464,
	"./Evaluation/ADR/List/index": 464,
	"./Evaluation/ADR/List/index.js": 464,
	"./Evaluation/ADR/List/statistics": 649,
	"./Evaluation/ADR/List/statistics.jsx": 649,
	"./Evaluation/ADR/List/style.css": 1063,
	"./Evaluation/ADR/Report": 465,
	"./Evaluation/ADR/Report/": 465,
	"./Evaluation/ADR/Report/DiagnosticEvaluationReport": 283,
	"./Evaluation/ADR/Report/DiagnosticEvaluationReport/": 283,
	"./Evaluation/ADR/Report/DiagnosticEvaluationReport/index": 283,
	"./Evaluation/ADR/Report/DiagnosticEvaluationReport/index.jsx": 283,
	"./Evaluation/ADR/Report/index": 465,
	"./Evaluation/ADR/Report/index.jsx": 465,
	"./Evaluation/ADR/Report/style.css": 814,
	"./Evaluation/ADR/Schedule": 466,
	"./Evaluation/ADR/Schedule/": 466,
	"./Evaluation/ADR/Schedule/index": 466,
	"./Evaluation/ADR/Schedule/index.jsx": 466,
	"./Evaluation/Allocate": 467,
	"./Evaluation/Allocate/": 467,
	"./Evaluation/Allocate/Allocate-documentation.md": 1429,
	"./Evaluation/Allocate/index": 467,
	"./Evaluation/Allocate/index.jsx": 467,
	"./Evaluation/Allocate/style.css": 1064,
	"./Evaluation/Bank/Allocate": 468,
	"./Evaluation/Bank/Allocate/": 468,
	"./Evaluation/Bank/Allocate/index": 468,
	"./Evaluation/Bank/Allocate/index.jsx": 468,
	"./Evaluation/Bank/Allocate/style.css": 1065,
	"./Evaluation/Bank/GradePanel": 537,
	"./Evaluation/Bank/GradePanel/": 537,
	"./Evaluation/Bank/GradePanel/index": 537,
	"./Evaluation/Bank/GradePanel/index.jsx": 537,
	"./Evaluation/Bank/GradePanel/styles.css": 1066,
	"./Evaluation/Bank/List": 469,
	"./Evaluation/Bank/List/": 469,
	"./Evaluation/Bank/List/index": 469,
	"./Evaluation/Bank/List/index.jsx": 469,
	"./Evaluation/Bank/Statistics": 470,
	"./Evaluation/Bank/Statistics/": 470,
	"./Evaluation/Bank/Statistics/index": 470,
	"./Evaluation/Bank/Statistics/index.jsx": 470,
	"./Evaluation/Bank/StudentStatistics": 471,
	"./Evaluation/Bank/StudentStatistics/": 471,
	"./Evaluation/Bank/StudentStatistics/index": 471,
	"./Evaluation/Bank/StudentStatistics/index.jsx": 471,
	"./Evaluation/Create": 472,
	"./Evaluation/Create/": 472,
	"./Evaluation/Create/Create-documentation.md": 1430,
	"./Evaluation/Create/index": 472,
	"./Evaluation/Create/index.jsx": 472,
	"./Evaluation/List": 473,
	"./Evaluation/List/": 473,
	"./Evaluation/List/List-documentation.md": 1431,
	"./Evaluation/List/index": 473,
	"./Evaluation/List/index.js": 473,
	"./Evaluation/List/statistics": 217,
	"./Evaluation/List/statistics.jsx": 217,
	"./Evaluation/List/style.css": 1062,
	"./Evaluation/Print": 474,
	"./Evaluation/Print/": 474,
	"./Evaluation/Print/Print-documentation.md": 1432,
	"./Evaluation/Print/index": 474,
	"./Evaluation/Print/index.jsx": 474,
	"./Evaluation/Question/Bank": 475,
	"./Evaluation/Question/Bank/": 475,
	"./Evaluation/Question/Bank/Bank-documentation.md": 1433,
	"./Evaluation/Question/Bank/Review/Edit": 522,
	"./Evaluation/Question/Bank/Review/Edit/": 522,
	"./Evaluation/Question/Bank/Review/Edit/index": 522,
	"./Evaluation/Question/Bank/Review/Edit/index.jsx": 522,
	"./Evaluation/Question/Bank/Review/Edit/styles.css": 1068,
	"./Evaluation/Question/Bank/Review/List": 476,
	"./Evaluation/Question/Bank/Review/List/": 476,
	"./Evaluation/Question/Bank/Review/List/index": 476,
	"./Evaluation/Question/Bank/Review/List/index.jsx": 476,
	"./Evaluation/Question/Bank/index": 475,
	"./Evaluation/Question/Bank/index.jsx": 475,
	"./Evaluation/Question/Bank/styles.css": 1067,
	"./Evaluation/Question/Create": 284,
	"./Evaluation/Question/Create/": 284,
	"./Evaluation/Question/Create/Create-documentation.md": 1434,
	"./Evaluation/Question/Create/index": 284,
	"./Evaluation/Question/Create/index.js": 284,
	"./Evaluation/Question/Create/styles.css": 1014,
	"./Evaluation/Question/List": 477,
	"./Evaluation/Question/List/": 477,
	"./Evaluation/Question/List/List-documentation.md": 1435,
	"./Evaluation/Question/List/index": 477,
	"./Evaluation/Question/List/index.js": 477,
	"./Evaluation/Question/Prototype": 478,
	"./Evaluation/Question/Prototype/": 478,
	"./Evaluation/Question/Prototype/Prototype-documentation.md": 1436,
	"./Evaluation/Question/Prototype/index": 478,
	"./Evaluation/Question/Prototype/index.js": 478,
	"./Evaluation/QuestionList/Do": 282,
	"./Evaluation/QuestionList/Do/": 282,
	"./Evaluation/QuestionList/Do/index": 282,
	"./Evaluation/QuestionList/Do/index.js": 282,
	"./Evaluation/QuestionList/Do/styles.css": 1015,
	"./Evaluation/QuestionList/List": 479,
	"./Evaluation/QuestionList/List/": 479,
	"./Evaluation/QuestionList/List/List-documentation.md": 1437,
	"./Evaluation/QuestionList/List/index": 479,
	"./Evaluation/QuestionList/List/index.js": 479,
	"./Evaluation/QuestionList/Prototype": 480,
	"./Evaluation/QuestionList/Prototype/": 480,
	"./Evaluation/QuestionList/Prototype/index": 480,
	"./Evaluation/QuestionList/Prototype/index.js": 480,
	"./Evaluation/Tv": 538,
	"./Evaluation/Tv/": 538,
	"./Evaluation/Tv/Tv-documentation.md": 1438,
	"./Evaluation/Tv/index": 538,
	"./Evaluation/Tv/index.js": 538,
	"./Evaluation/Tv/style.css": 1069,
	"./Evaluation/TypeQuestion/Create": 481,
	"./Evaluation/TypeQuestion/Create/": 481,
	"./Evaluation/TypeQuestion/Create/Create-documentation.md": 1439,
	"./Evaluation/TypeQuestion/Create/index": 481,
	"./Evaluation/TypeQuestion/Create/index.js": 481,
	"./Evaluation/TypeQuestion/List": 482,
	"./Evaluation/TypeQuestion/List/": 482,
	"./Evaluation/TypeQuestion/List/List-documentation.md": 1440,
	"./Evaluation/TypeQuestion/List/index": 482,
	"./Evaluation/TypeQuestion/List/index.js": 482,
	"./ExternalAuth": 261,
	"./ExternalAuth/": 261,
	"./ExternalAuth/ExternalAuth-documentation.md": 1441,
	"./ExternalAuth/index": 261,
	"./ExternalAuth/index.jsx": 261,
	"./ForgotPassword": 278,
	"./ForgotPassword/": 278,
	"./ForgotPassword/ForgotPassword-documentation.md": 1442,
	"./ForgotPassword/index": 278,
	"./ForgotPassword/index.jsx": 278,
	"./Formulario/Allocate": 539,
	"./Formulario/Allocate/": 539,
	"./Formulario/Allocate/index": 539,
	"./Formulario/Allocate/index.jsx": 539,
	"./Formulario/Allocate/styles.css": 1070,
	"./Formulario/Index": 523,
	"./Formulario/Index/": 523,
	"./Formulario/Index/index": 523,
	"./Formulario/Index/index.jsx": 523,
	"./Gamification/Achievements": 483,
	"./Gamification/Achievements/": 483,
	"./Gamification/Achievements/ColecaoDeCartasDoAluno": 242,
	"./Gamification/Achievements/ColecaoDeCartasDoAluno.jsx": 242,
	"./Gamification/Achievements/ColecaoDeCartasDoAluno.test": 815,
	"./Gamification/Achievements/ColecaoDeCartasDoAluno.test.jsx": 815,
	"./Gamification/Achievements/Medalhas": 184,
	"./Gamification/Achievements/Medalhas.jsx": 184,
	"./Gamification/Achievements/Medalhas.test": 818,
	"./Gamification/Achievements/Medalhas.test.jsx": 818,
	"./Gamification/Achievements/SecaoDeConquista": 220,
	"./Gamification/Achievements/SecaoDeConquista.jsx": 220,
	"./Gamification/Achievements/SecaoDeConquista.test": 819,
	"./Gamification/Achievements/SecaoDeConquista.test.jsx": 819,
	"./Gamification/Achievements/index": 483,
	"./Gamification/Achievements/index.js": 483,
	"./Gamification/Achievements/styles.css": 1071,
	"./Gamification/Achievements/tiposDeConquista": 605,
	"./Gamification/Achievements/tiposDeConquista.js": 605,
	"./Guest": 279,
	"./Guest/": 279,
	"./Guest/Guest-documentation.md": 1453,
	"./Guest/index": 279,
	"./Guest/index.js": 279,
	"./Guest/style.css": 983,
	"./Help/Faq/List": 484,
	"./Help/Faq/List/": 484,
	"./Help/Faq/List/List-documentation.md": 1454,
	"./Help/Faq/List/index": 484,
	"./Help/Faq/List/index.js": 484,
	"./Help/Faq/List/style.css": 1074,
	"./Help/Faq/Show": 485,
	"./Help/Faq/Show/": 485,
	"./Help/Faq/Show/Show-documentation.md": 1455,
	"./Help/Faq/Show/index": 485,
	"./Help/Faq/Show/index.js": 485,
	"./Help/Faq/Show/style.css": 1075,
	"./Help/Helpdesk/Category/Create": 486,
	"./Help/Helpdesk/Category/Create/": 486,
	"./Help/Helpdesk/Category/Create/Create-documentation.md": 1456,
	"./Help/Helpdesk/Category/Create/index": 486,
	"./Help/Helpdesk/Category/Create/index.js": 486,
	"./Help/Helpdesk/Category/List": 487,
	"./Help/Helpdesk/Category/List/": 487,
	"./Help/Helpdesk/Category/List/List-documentation.md": 1457,
	"./Help/Helpdesk/Category/List/index": 487,
	"./Help/Helpdesk/Category/List/index.js": 487,
	"./Help/Helpdesk/List": 488,
	"./Help/Helpdesk/List/": 488,
	"./Help/Helpdesk/List/List-documentation.md": 1458,
	"./Help/Helpdesk/List/index": 488,
	"./Help/Helpdesk/List/index.js": 488,
	"./Help/Helpdesk/List/style.css": 1076,
	"./Help/Helpdesk/Me": 489,
	"./Help/Helpdesk/Me/": 489,
	"./Help/Helpdesk/Me/Me-documentation.md": 1459,
	"./Help/Helpdesk/Me/index": 489,
	"./Help/Helpdesk/Me/index.js": 489,
	"./Help/Helpdesk/Me/style.css": 1077,
	"./Help/Helpdesk/Show": 490,
	"./Help/Helpdesk/Show/": 490,
	"./Help/Helpdesk/Show/Show-documentation.md": 1460,
	"./Help/Helpdesk/Show/index": 490,
	"./Help/Helpdesk/Show/index.js": 490,
	"./Help/Helpdesk/Show/style.css": 1078,
	"./Help/Tutorials": 540,
	"./Help/Tutorials/": 540,
	"./Help/Tutorials/Tutorials-documentation.md": 1461,
	"./Help/Tutorials/index": 540,
	"./Help/Tutorials/index.jsx": 540,
	"./Import": 541,
	"./Import/": 541,
	"./Import/Import-documentation.md": 1462,
	"./Import/ImportAllocateStudents": 491,
	"./Import/ImportAllocateStudents/": 491,
	"./Import/ImportAllocateStudents/index": 491,
	"./Import/ImportAllocateStudents/index.js": 491,
	"./Import/ImportAllocateStudents/style.css": 1079,
	"./Import/Students": 492,
	"./Import/Students/": 492,
	"./Import/Students/index": 492,
	"./Import/Students/index.js": 492,
	"./Import/Students/style.css": 1080,
	"./Import/index": 541,
	"./Import/index.js": 541,
	"./Import/indexLegacy": 821,
	"./Import/indexLegacy.js": 821,
	"./Import/style.css": 820,
	"./InteligenciaEducacional": 493,
	"./InteligenciaEducacional/": 493,
	"./InteligenciaEducacional/App": 666,
	"./InteligenciaEducacional/App.jsx": 666,
	"./InteligenciaEducacional/InteligenciaEducacional": 650,
	"./InteligenciaEducacional/InteligenciaEducacional.jsx": 650,
	"./InteligenciaEducacional/components/BuscaNome": 191,
	"./InteligenciaEducacional/components/BuscaNome.jsx": 191,
	"./InteligenciaEducacional/components/PainelShell": 190,
	"./InteligenciaEducacional/components/PainelShell.jsx": 190,
	"./InteligenciaEducacional/components/PeriodoFiltro": 288,
	"./InteligenciaEducacional/components/PeriodoFiltro.jsx": 288,
	"./InteligenciaEducacional/components/charts/Charts": 146,
	"./InteligenciaEducacional/components/charts/Charts.jsx": 146,
	"./InteligenciaEducacional/components/charts/EvolucaoTemporal": 555,
	"./InteligenciaEducacional/components/charts/EvolucaoTemporal.jsx": 555,
	"./InteligenciaEducacional/components/charts/FaixaDonutCard": 652,
	"./InteligenciaEducacional/components/charts/FaixaDonutCard.jsx": 652,
	"./InteligenciaEducacional/components/charts/FaixaKpiCompacta": 656,
	"./InteligenciaEducacional/components/charts/FaixaKpiCompacta.jsx": 656,
	"./InteligenciaEducacional/components/layout/Breadcrumb": 557,
	"./InteligenciaEducacional/components/layout/Breadcrumb.jsx": 557,
	"./InteligenciaEducacional/components/layout/EngajamentoCell": 320,
	"./InteligenciaEducacional/components/layout/EngajamentoCell.jsx": 320,
	"./InteligenciaEducacional/components/layout/KpiCard": 116,
	"./InteligenciaEducacional/components/layout/KpiCard.jsx": 116,
	"./InteligenciaEducacional/components/layout/NotaCell": 321,
	"./InteligenciaEducacional/components/layout/NotaCell.jsx": 321,
	"./InteligenciaEducacional/components/layout/RankingTabela": 291,
	"./InteligenciaEducacional/components/layout/RankingTabela.jsx": 291,
	"./InteligenciaEducacional/components/ui/HoverPopover": 556,
	"./InteligenciaEducacional/components/ui/HoverPopover.jsx": 556,
	"./InteligenciaEducacional/components/ui/PortalIE": 286,
	"./InteligenciaEducacional/components/ui/PortalIE.jsx": 286,
	"./InteligenciaEducacional/components/ui/primitives": 38,
	"./InteligenciaEducacional/components/ui/primitives.jsx": 38,
	"./InteligenciaEducacional/config/perfilPorRole": 94,
	"./InteligenciaEducacional/config/perfilPorRole.js": 94,
	"./InteligenciaEducacional/config/perfilPorRole.test": 832,
	"./InteligenciaEducacional/config/perfilPorRole.test.js": 832,
	"./InteligenciaEducacional/context/PerfilContext": 262,
	"./InteligenciaEducacional/context/PerfilContext.jsx": 262,
	"./InteligenciaEducacional/index": 493,
	"./InteligenciaEducacional/index.js": 493,
	"./InteligenciaEducacional/lib/api": 62,
	"./InteligenciaEducacional/lib/api.js": 62,
	"./InteligenciaEducacional/lib/busca": 111,
	"./InteligenciaEducacional/lib/busca.js": 111,
	"./InteligenciaEducacional/lib/busca.test": 833,
	"./InteligenciaEducacional/lib/busca.test.js": 833,
	"./InteligenciaEducacional/lib/escopo": 185,
	"./InteligenciaEducacional/lib/escopo.js": 185,
	"./InteligenciaEducacional/lib/escopo.test": 834,
	"./InteligenciaEducacional/lib/escopo.test.js": 834,
	"./InteligenciaEducacional/lib/faixa": 285,
	"./InteligenciaEducacional/lib/faixa.js": 285,
	"./InteligenciaEducacional/lib/format": 57,
	"./InteligenciaEducacional/lib/format.js": 57,
	"./InteligenciaEducacional/lib/mock/fixtures": 250,
	"./InteligenciaEducacional/lib/mock/fixtures.json": 250,
	"./InteligenciaEducacional/lib/mock/router": 736,
	"./InteligenciaEducacional/lib/mock/router.js": 736,
	"./InteligenciaEducacional/lib/perfilEngajamento": 654,
	"./InteligenciaEducacional/lib/perfilEngajamento.js": 654,
	"./InteligenciaEducacional/lib/periodo": 150,
	"./InteligenciaEducacional/lib/periodo.js": 150,
	"./InteligenciaEducacional/lib/seriesPorTipo": 117,
	"./InteligenciaEducacional/lib/seriesPorTipo.js": 117,
	"./InteligenciaEducacional/lib/seriesPorTipo.test": 835,
	"./InteligenciaEducacional/lib/seriesPorTipo.test.js": 835,
	"./InteligenciaEducacional/lib/transport": 129,
	"./InteligenciaEducacional/lib/transport.js": 129,
	"./InteligenciaEducacional/lib/useAsync": 118,
	"./InteligenciaEducacional/lib/useAsync.js": 118,
	"./InteligenciaEducacional/lib/useContextoIE": 289,
	"./InteligenciaEducacional/lib/useContextoIE.js": 289,
	"./InteligenciaEducacional/lib/useDebounce": 657,
	"./InteligenciaEducacional/lib/useDebounce.js": 657,
	"./InteligenciaEducacional/lib/useRevealOnScroll": 553,
	"./InteligenciaEducacional/lib/useRevealOnScroll.js": 553,
	"./InteligenciaEducacional/lib/utils": 66,
	"./InteligenciaEducacional/lib/utils.js": 66,
	"./InteligenciaEducacional/pages/admin/AdminApp": 651,
	"./InteligenciaEducacional/pages/admin/AdminApp.jsx": 651,
	"./InteligenciaEducacional/pages/admin/AdminPainel": 554,
	"./InteligenciaEducacional/pages/admin/AdminPainel.jsx": 554,
	"./InteligenciaEducacional/pages/gestor/GestorApp": 558,
	"./InteligenciaEducacional/pages/gestor/GestorApp.jsx": 558,
	"./InteligenciaEducacional/pages/gestor/GestorApp.test": 836,
	"./InteligenciaEducacional/pages/gestor/GestorApp.test.jsx": 836,
	"./InteligenciaEducacional/pages/gestor/GestorPainel": 229,
	"./InteligenciaEducacional/pages/gestor/GestorPainel.jsx": 229,
	"./InteligenciaEducacional/pages/gestor/GestorPainel.test": 837,
	"./InteligenciaEducacional/pages/gestor/GestorPainel.test.jsx": 837,
	"./InteligenciaEducacional/pages/professor/AlunoDrawer": 653,
	"./InteligenciaEducacional/pages/professor/AlunoDrawer.jsx": 653,
	"./InteligenciaEducacional/pages/professor/AlunosTabela": 655,
	"./InteligenciaEducacional/pages/professor/AlunosTabela.jsx": 655,
	"./InteligenciaEducacional/pages/professor/ProfessorApp": 658,
	"./InteligenciaEducacional/pages/professor/ProfessorApp.jsx": 658,
	"./InteligenciaEducacional/pages/professor/TurmaPainel": 287,
	"./InteligenciaEducacional/pages/professor/TurmaPainel.jsx": 287,
	"./InteligenciaEducacional/styles/componentes.css": 1537,
	"./InteligenciaEducacional/styles/generated.css": 1099,
	"./InteligenciaEducacional/styles/tokens.css": 1538,
	"./LessonPlans": 495,
	"./LessonPlans/": 495,
	"./LessonPlans/View": 542,
	"./LessonPlans/View/": 542,
	"./LessonPlans/View/index": 542,
	"./LessonPlans/View/index.jsx": 542,
	"./LessonPlans/index": 495,
	"./LessonPlans/index.jsx": 495,
	"./Login": 280,
	"./Login/": 280,
	"./Login/Login-documentation.md": 1539,
	"./Login/LoginExternal": 639,
	"./Login/LoginExternal.jsx": 639,
	"./Login/index": 280,
	"./Login/index.js": 280,
	"./Logout": 281,
	"./Logout/": 281,
	"./Logout/Logout-documentation.md": 1540,
	"./Logout/index": 281,
	"./Logout/index.js": 281,
	"./Logs": 543,
	"./Logs/": 543,
	"./Logs/Logs-documentation.md": 1541,
	"./Logs/index": 543,
	"./Logs/index.js": 543,
	"./Management": 544,
	"./Management/": 544,
	"./Management/Management-documentation.md": 1542,
	"./Management/index": 544,
	"./Management/index.js": 544,
	"./Management/style.scss": 838,
	"./Management/toRemove": 839,
	"./Management/toRemove.js": 839,
	"./News/Panel": 545,
	"./News/Panel/": 545,
	"./News/Panel/Panel-documentation.md": 1543,
	"./News/Panel/index": 545,
	"./News/Panel/index.jsx": 545,
	"./Offline/Register/Create": 496,
	"./Offline/Register/Create/": 496,
	"./Offline/Register/Create/Create-documentation.md": 1544,
	"./Offline/Register/Create/index": 496,
	"./Offline/Register/Create/index.jsx": 496,
	"./Offline/Register/Create/style.css": 1100,
	"./Offline/Register/Edit": 497,
	"./Offline/Register/Edit/": 497,
	"./Offline/Register/Edit/Edit-documentation.md": 1545,
	"./Offline/Register/Edit/index": 497,
	"./Offline/Register/Edit/index.jsx": 497,
	"./Offline/Register/Edit/styles.css": 1546,
	"./Offline/Register/List": 546,
	"./Offline/Register/List/": 546,
	"./Offline/Register/List/List-documentation.md": 1547,
	"./Offline/Register/List/index": 546,
	"./Offline/Register/List/index.jsx": 546,
	"./Offline/Register/List/styles.css": 1548,
	"./Offline/Register/View": 498,
	"./Offline/Register/View/": 498,
	"./Offline/Register/View/View-documentation.md": 1549,
	"./Offline/Register/View/index": 498,
	"./Offline/Register/View/index.jsx": 498,
	"./Olympics/Activity": 499,
	"./Olympics/Activity/": 499,
	"./Olympics/Activity/index": 499,
	"./Olympics/Activity/index.jsx": 499,
	"./Olympics/Conecta.png": 561,
	"./Olympics/Dashboard": 547,
	"./Olympics/Dashboard/": 547,
	"./Olympics/Dashboard/index": 547,
	"./Olympics/Dashboard/index.js": 547,
	"./Olympics/Dashboard/styles.css": 1101,
	"./Olympics/Leaderboard/School": 500,
	"./Olympics/Leaderboard/School/": 500,
	"./Olympics/Leaderboard/School/index": 500,
	"./Olympics/Leaderboard/School/index.js": 500,
	"./Olympics/Leaderboard/Student": 501,
	"./Olympics/Leaderboard/Student/": 501,
	"./Olympics/Leaderboard/Student/index": 501,
	"./Olympics/Leaderboard/Student/index.js": 501,
	"./Olympics/List": 502,
	"./Olympics/List/": 502,
	"./Olympics/List/index": 502,
	"./Olympics/List/index.js": 502,
	"./PDF": 517,
	"./PDF/": 517,
	"./PDF/PDF-documentation.md": 1551,
	"./PDF/index": 517,
	"./PDF/index.jsx": 517,
	"./PedagogicalFollowUps": 548,
	"./PedagogicalFollowUps/": 548,
	"./PedagogicalFollowUps/Allocate": 503,
	"./PedagogicalFollowUps/Allocate/": 503,
	"./PedagogicalFollowUps/Allocate/index": 503,
	"./PedagogicalFollowUps/Allocate/index.jsx": 503,
	"./PedagogicalFollowUps/Consolidated": 504,
	"./PedagogicalFollowUps/Consolidated/": 504,
	"./PedagogicalFollowUps/Consolidated/index": 504,
	"./PedagogicalFollowUps/Consolidated/index.jsx": 504,
	"./PedagogicalFollowUps/Consolidated/newConsolidated": 505,
	"./PedagogicalFollowUps/Consolidated/newConsolidated/": 505,
	"./PedagogicalFollowUps/Consolidated/newConsolidated/index": 505,
	"./PedagogicalFollowUps/Consolidated/newConsolidated/index.jsx": 505,
	"./PedagogicalFollowUps/Consolidated/newConsolidated/styles.css": 1103,
	"./PedagogicalFollowUps/Consolidated/styles.css": 1102,
	"./PedagogicalFollowUps/Create": 549,
	"./PedagogicalFollowUps/Create/": 549,
	"./PedagogicalFollowUps/Create/index": 549,
	"./PedagogicalFollowUps/Create/index.jsx": 549,
	"./PedagogicalFollowUps/Execution": 506,
	"./PedagogicalFollowUps/Execution/": 506,
	"./PedagogicalFollowUps/Execution/Room": 507,
	"./PedagogicalFollowUps/Execution/Room/": 507,
	"./PedagogicalFollowUps/Execution/Room/index": 507,
	"./PedagogicalFollowUps/Execution/Room/index.jsx": 507,
	"./PedagogicalFollowUps/Execution/Room/styles.css": 1105,
	"./PedagogicalFollowUps/Execution/index": 506,
	"./PedagogicalFollowUps/Execution/index.jsx": 506,
	"./PedagogicalFollowUps/Execution/styles.css": 1104,
	"./PedagogicalFollowUps/List": 508,
	"./PedagogicalFollowUps/List/": 508,
	"./PedagogicalFollowUps/List/index": 508,
	"./PedagogicalFollowUps/List/index.jsx": 508,
	"./PedagogicalFollowUps/index": 548,
	"./PedagogicalFollowUps/index.jsx": 548,
	"./PendingLOs/List": 527,
	"./PendingLOs/List/": 527,
	"./PendingLOs/List/List-documentation.md": 1552,
	"./PendingLOs/List/index": 527,
	"./PendingLOs/List/index.jsx": 527,
	"./PortalResponsavel": 509,
	"./PortalResponsavel/": 509,
	"./PortalResponsavel/App": 660,
	"./PortalResponsavel/App.jsx": 660,
	"./PortalResponsavel/PortalResponsavel": 659,
	"./PortalResponsavel/PortalResponsavel.jsx": 659,
	"./PortalResponsavel/components/ComparativoNota": 662,
	"./PortalResponsavel/components/ComparativoNota.jsx": 662,
	"./PortalResponsavel/components/LinhaTemporal": 606,
	"./PortalResponsavel/components/LinhaTemporal.jsx": 606,
	"./PortalResponsavel/components/PainelAluno": 661,
	"./PortalResponsavel/components/PainelAluno.jsx": 661,
	"./PortalResponsavel/components/SeletorAluno": 663,
	"./PortalResponsavel/components/SeletorAluno.jsx": 663,
	"./PortalResponsavel/index": 509,
	"./PortalResponsavel/index.js": 509,
	"./PortalResponsavel/lib/api": 292,
	"./PortalResponsavel/lib/api.js": 292,
	"./PortalResponsavel/lib/format": 210,
	"./PortalResponsavel/lib/format.js": 210,
	"./PortalResponsavel/lib/transport": 322,
	"./PortalResponsavel/lib/transport.js": 322,
	"./PortalResponsavel/lib/useAsync": 293,
	"./PortalResponsavel/lib/useAsync.js": 293,
	"./PortalResponsavel/lib/vinculos": 664,
	"./PortalResponsavel/lib/vinculos.js": 664,
	"./Profile": 528,
	"./Profile/": 528,
	"./Profile/Profile-documentation.md": 1553,
	"./Profile/SummaryStudent": 510,
	"./Profile/SummaryStudent/": 510,
	"./Profile/SummaryStudent/index": 510,
	"./Profile/SummaryStudent/index.jsx": 510,
	"./Profile/SummaryStudent/styles.css": 1107,
	"./Profile/index": 528,
	"./Profile/index.js": 528,
	"./Profile/styles.css": 1106,
	"./Report/Access": 511,
	"./Report/Access/": 511,
	"./Report/Access/Access-documentation.md": 1554,
	"./Report/Access/index": 511,
	"./Report/Access/index.jsx": 511,
	"./Report/Trails": 512,
	"./Report/Trails/": 512,
	"./Report/Trails/index": 512,
	"./Report/Trails/index.jsx": 512,
	"./Report/Trails/styles.css": 1108,
	"./Root": 665,
	"./Root.js": 665,
	"./Stift/View": 550,
	"./Stift/View/": 550,
	"./Stift/View/View-documentation.md": 1555,
	"./Stift/View/index": 550,
	"./Stift/View/index.js": 550,
	"./Tools/Gerador/Create": 513,
	"./Tools/Gerador/Create/": 513,
	"./Tools/Gerador/Create/Create-documentation.md": 1556,
	"./Tools/Gerador/Create/index": 513,
	"./Tools/Gerador/Create/index.jsx": 513,
	"./Tools/Gerador/Gerador-documentation.md": 1557,
	"./Tools/Gerador/List": 514,
	"./Tools/Gerador/List/": 514,
	"./Tools/Gerador/List/List-documentation.md": 1558,
	"./Tools/Gerador/List/index": 514,
	"./Tools/Gerador/List/index.jsx": 514,
	"./Tools/Gerador/Show": 515,
	"./Tools/Gerador/Show/": 515,
	"./Tools/Gerador/Show/Show-documentation.md": 1559,
	"./Tools/Gerador/Show/index": 515,
	"./Tools/Gerador/Show/index.jsx": 515,
	"./Tools/Literarte": 519,
	"./Tools/Literarte/": 519,
	"./Tools/Literarte/Literarte-documentation.md": 1560,
	"./Tools/Literarte/index": 519,
	"./Tools/Literarte/index.jsx": 519,
	"./Tools/Newton": 551,
	"./Tools/Newton/": 551,
	"./Tools/Newton/Newton-documentation.md": 1561,
	"./Tools/Newton/index": 551,
	"./Tools/Newton/index.js": 551,
	"./Tools/Newton/style.css": 1109,
	"./styles.css": 1110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1184;